import React, { useState } from "react";
import QuizList from "../../components/Dashboard/Quizzes/QuizList";
import QuizzesModal from "../../components/Dashboard/Quizzes/QuizzesModal";
import Navbar from "../../components/Navbar";

export default function Quizzes() {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);
  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <div className="px-3 py-20 bg-opacity-10">
            <div className="w-full flex">
              <button className="btn ml-auto" onClick={toggleModal}>
                Add Quiz
              </button>
            </div>

            <QuizList />
          </div>
          {showModal && (
            <div className="modal-container">
              <QuizzesModal open={showModal} control={toggleModal} task="Add" />
            </div>
          )}
        </div>
      </section>
    </>
  );
}
